import { render, staticRenderFns } from "./baseSelect.vue?vue&type=template&id=b4976cde&"
import script from "./baseSelect.vue?vue&type=script&lang=ts&"
export * from "./baseSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports